var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomBlock8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 200,
    viewBox: "0 0 400 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 200,
    fill: "#F6F6FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2013_2527)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 112,
    transform: "translate(0 44)",
    fill: "#B5C3E5"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 44,
    width: 400,
    height: 112,
    fill: "#F6F6FB"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -152.735,
    y1: 49.6568,
    x2: 164.049,
    y2: -267.127,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -145.664,
    y1: 56.7279,
    x2: 171.12,
    y2: -260.056,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -138.593,
    y1: 63.7989,
    x2: 178.191,
    y2: -252.985,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -131.522,
    y1: 70.87,
    x2: 185.262,
    y2: -245.914,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -124.451,
    y1: 77.941,
    x2: 192.333,
    y2: -238.843,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -117.38,
    y1: 85.0121,
    x2: 199.404,
    y2: -231.772,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -110.309,
    y1: 92.0832,
    x2: 206.475,
    y2: -224.701,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -103.238,
    y1: 99.1543,
    x2: 213.546,
    y2: -217.63,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -96.1664,
    y1: 106.225,
    x2: 220.617,
    y2: -210.559,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -89.0954,
    y1: 113.296,
    x2: 227.688,
    y2: -203.488,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -82.0243,
    y1: 120.368,
    x2: 234.76,
    y2: -196.416,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -74.9533,
    y1: 127.439,
    x2: 241.831,
    y2: -189.345,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -67.8822,
    y1: 134.51,
    x2: 248.902,
    y2: -182.274,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -60.8112,
    y1: 141.581,
    x2: 255.973,
    y2: -175.203,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -53.7401,
    y1: 148.652,
    x2: 263.044,
    y2: -168.132,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -46.6691,
    y1: 155.723,
    x2: 270.115,
    y2: -161.061,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -39.5981,
    y1: 162.794,
    x2: 277.186,
    y2: -153.99,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -32.527,
    y1: 169.865,
    x2: 284.257,
    y2: -146.919,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -25.456,
    y1: 176.936,
    x2: 291.328,
    y2: -139.848,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -18.3847,
    y1: 184.007,
    x2: 298.399,
    y2: -132.777,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -11.3136,
    y1: 191.078,
    x2: 305.47,
    y2: -125.706,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.24258,
    y1: 198.149,
    x2: 312.541,
    y2: -118.635,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.82846,
    y1: 205.22,
    x2: 319.612,
    y2: -111.564,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.89951,
    y1: 212.291,
    x2: 326.683,
    y2: -104.493,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.9706,
    y1: 219.362,
    x2: 333.754,
    y2: -97.4215,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.0416,
    y1: 226.433,
    x2: 340.825,
    y2: -90.3504,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.1126,
    y1: 233.504,
    x2: 347.897,
    y2: -83.2794,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.1837,
    y1: 240.576,
    x2: 354.968,
    y2: -76.2083,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.2547,
    y1: 247.647,
    x2: 362.039,
    y2: -69.137,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.326,
    y1: 254.718,
    x2: 369.11,
    y2: -62.0662,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.3971,
    y1: 261.789,
    x2: 376.181,
    y2: -54.9949,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.4681,
    y1: 268.86,
    x2: 383.252,
    y2: -47.9239,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.5392,
    y1: 275.931,
    x2: 390.323,
    y2: -40.8529,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.6102,
    y1: 283.002,
    x2: 397.394,
    y2: -33.7818,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.6812,
    y1: 290.073,
    x2: 404.465,
    y2: -26.7108,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.7523,
    y1: 297.144,
    x2: 411.536,
    y2: -19.6397,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.823,
    y1: 304.215,
    x2: 418.607,
    y2: -12.5687,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.894,
    y1: 311.286,
    x2: 425.678,
    y2: -5.49763,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 115.965,
    y1: 318.357,
    x2: 432.749,
    y2: 1.57341,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.036,
    y1: 325.429,
    x2: 439.82,
    y2: 8.6447,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.108,
    y1: 332.499,
    x2: 446.892,
    y2: 15.7155,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137.179,
    y1: 339.571,
    x2: 453.963,
    y2: 22.7868,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.25,
    y1: 346.642,
    x2: 461.034,
    y2: 29.8578,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.321,
    y1: 353.713,
    x2: 468.105,
    y2: 36.9289,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.392,
    y1: 360.784,
    x2: 475.176,
    y2: 43.9999,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.463,
    y1: 367.855,
    x2: 482.247,
    y2: 51.071,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172.534,
    y1: 374.926,
    x2: 489.318,
    y2: 58.142,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 179.605,
    y1: 381.997,
    x2: 496.389,
    y2: 65.2131,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.676,
    y1: 389.068,
    x2: 503.46,
    y2: 72.2841,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.747,
    y1: 396.139,
    x2: 510.531,
    y2: 79.3551,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200.818,
    y1: 403.21,
    x2: 517.602,
    y2: 86.4264,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 207.889,
    y1: 410.281,
    x2: 524.673,
    y2: 93.4972,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.961,
    y1: 417.352,
    x2: 531.744,
    y2: 100.569,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 222.032,
    y1: 424.423,
    x2: 538.815,
    y2: 107.64,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.103,
    y1: 431.494,
    x2: 545.886,
    y2: 114.711,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 236.174,
    y1: 438.566,
    x2: 552.958,
    y2: 121.782,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243.245,
    y1: 445.637,
    x2: 560.029,
    y2: 128.853,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 250.316,
    y1: 452.708,
    x2: 567.1,
    y2: 135.924,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.387,
    y1: 459.779,
    x2: 574.171,
    y2: 142.995,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264.458,
    y1: 466.85,
    x2: 581.242,
    y2: 150.066,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 271.529,
    y1: 473.921,
    x2: 588.313,
    y2: 157.137,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.832 112.39C113.058 112.39 111.403 112.097 109.866 111.513C108.352 110.907 107.021 110.063 105.874 108.982C104.727 107.9 103.829 106.634 103.18 105.184C102.553 103.713 102.239 102.122 102.239 100.413C102.239 98.6818 102.553 97.0914 103.18 95.6416C103.829 94.1919 104.717 92.9369 105.842 91.8766C106.989 90.8163 108.319 89.9941 109.834 89.4099C111.349 88.804 112.993 88.5011 114.767 88.5011C116.563 88.5011 118.208 88.7824 119.701 89.345C121.194 89.9075 122.492 90.6865 123.596 91.6819L119.279 96.0311C118.76 95.4685 118.121 95.025 117.364 94.7004C116.628 94.3758 115.763 94.2135 114.767 94.2135C113.902 94.2135 113.101 94.3542 112.366 94.6355C111.652 94.9168 111.035 95.3279 110.516 95.8688C109.996 96.4098 109.585 97.0698 109.282 97.8487C109.001 98.6061 108.86 99.4608 108.86 100.413C108.86 101.387 109.001 102.263 109.282 103.042C109.585 103.799 109.996 104.448 110.516 104.989C111.035 105.53 111.652 105.952 112.366 106.255C113.101 106.536 113.902 106.677 114.767 106.677C115.741 106.677 116.607 106.526 117.364 106.223C118.143 105.92 118.814 105.476 119.376 104.892L123.726 109.241C122.579 110.237 121.291 111.016 119.863 111.578C118.435 112.119 116.758 112.39 114.832 112.39Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.978 112.39C134.944 112.39 133.17 111.978 131.655 111.156C130.141 110.312 128.961 109.155 128.117 107.683C127.274 106.212 126.852 104.524 126.852 102.62V88.8906H133.343V103.204C133.343 103.94 133.505 104.567 133.83 105.087C134.155 105.606 134.587 106.006 135.128 106.288C135.691 106.547 136.308 106.677 136.978 106.677C137.671 106.677 138.277 106.547 138.796 106.288C139.337 106.006 139.759 105.617 140.062 105.119C140.365 104.6 140.516 103.972 140.516 103.237V88.8906H147.04V102.652C147.04 104.557 146.618 106.244 145.774 107.716C144.952 109.165 143.783 110.312 142.269 111.156C140.776 111.978 139.012 112.39 136.978 112.39Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.954 112.39C156.984 112.39 155.264 112.108 153.793 111.546C152.343 110.961 151.002 110.042 149.768 108.787L153.825 104.73C154.669 105.53 155.556 106.147 156.487 106.58C157.417 106.991 158.413 107.196 159.473 107.196C160.36 107.196 161.031 107.067 161.485 106.807C161.94 106.526 162.167 106.147 162.167 105.671C162.167 105.195 161.972 104.805 161.583 104.502C161.193 104.178 160.674 103.897 160.025 103.659C159.397 103.399 158.694 103.139 157.915 102.88C157.158 102.62 156.4 102.306 155.643 101.938C154.886 101.57 154.182 101.127 153.533 100.608C152.906 100.067 152.397 99.4067 152.008 98.6277C151.618 97.8271 151.424 96.8534 151.424 95.7066C151.424 94.2135 151.781 92.9261 152.495 91.8442C153.209 90.7623 154.215 89.94 155.513 89.3774C156.811 88.7932 158.337 88.5011 160.09 88.5011C161.821 88.5011 163.422 88.7824 164.893 89.345C166.386 89.8859 167.62 90.6649 168.593 91.6819L164.504 95.739C163.79 95.0466 163.076 94.5381 162.362 94.2135C161.648 93.8673 160.869 93.6942 160.025 93.6942C159.354 93.6942 158.813 93.8024 158.402 94.0188C158.012 94.2352 157.818 94.5597 157.818 94.9925C157.818 95.4469 158.012 95.8256 158.402 96.1285C158.791 96.4098 159.3 96.6695 159.927 96.9075C160.576 97.1455 161.28 97.3943 162.037 97.654C162.816 97.9136 163.584 98.2274 164.341 98.5952C165.099 98.9415 165.791 99.3959 166.419 99.9584C167.068 100.499 167.587 101.181 167.977 102.003C168.366 102.825 168.561 103.821 168.561 104.989C168.561 107.348 167.717 109.176 166.029 110.475C164.363 111.751 162.005 112.39 158.954 112.39Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.354 112V88.8906H183.845V112H177.354ZM170.441 94.4083V88.8906H190.791V94.4083H170.441Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.035 112.454C203.218 112.454 201.541 112.152 200.004 111.546C198.49 110.94 197.159 110.096 196.012 109.014C194.887 107.932 194.011 106.655 193.383 105.184C192.756 103.713 192.442 102.122 192.442 100.413C192.442 98.6818 192.745 97.0914 193.351 95.6416C193.978 94.1919 194.855 92.9261 195.98 91.8442C197.105 90.7623 198.425 89.9292 199.94 89.345C201.476 88.7391 203.153 88.4362 204.97 88.4362C206.788 88.4362 208.454 88.7391 209.969 89.345C211.505 89.9292 212.836 90.7623 213.961 91.8442C215.086 92.9261 215.952 94.2027 216.558 95.6741C217.185 97.1239 217.499 98.7143 217.499 100.445C217.499 102.155 217.185 103.745 216.558 105.216C215.952 106.666 215.086 107.943 213.961 109.046C212.836 110.128 211.516 110.972 210.001 111.578C208.487 112.162 206.831 112.454 205.035 112.454ZM204.97 106.742C206.182 106.742 207.232 106.482 208.119 105.963C209.006 105.444 209.688 104.708 210.164 103.756C210.64 102.804 210.878 101.689 210.878 100.413C210.878 99.4608 210.737 98.6061 210.456 97.8487C210.196 97.0698 209.807 96.4098 209.287 95.8688C208.768 95.3063 208.14 94.8843 207.405 94.603C206.691 94.3001 205.879 94.1486 204.97 94.1486C203.759 94.1486 202.709 94.4083 201.822 94.9276C200.935 95.4253 200.253 96.1501 199.777 97.1022C199.301 98.0327 199.063 99.1362 199.063 100.413C199.063 101.387 199.193 102.263 199.453 103.042C199.734 103.821 200.134 104.492 200.654 105.054C201.173 105.595 201.79 106.017 202.504 106.32C203.239 106.601 204.062 106.742 204.97 106.742Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.47 112V88.8906H226.177L234.778 101.484H232.733L241.302 88.8906H246.008V112H239.581V99.5365L240.523 99.7962L235.816 106.547H231.662L226.988 99.7962L227.897 99.5365V112H221.47Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.609 112L270.634 88.8906H275.697L271.64 112H266.609ZM257.229 105.736V101.516H276.508V105.736H257.229ZM258.981 112L263.039 88.8906H268.037L264.045 112H258.981ZM258.397 98.8874V94.7004H277.644V98.8874H258.397Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.154 112.39C287.401 112.39 285.876 112.097 284.578 111.513C283.279 110.907 282.273 110.096 281.559 109.079C280.845 108.04 280.488 106.861 280.488 105.541C280.488 104.394 280.704 103.377 281.137 102.49C281.57 101.603 282.165 100.878 282.922 100.315C283.701 99.7529 284.578 99.385 285.551 99.2119L285.454 100.283C284.588 100.132 283.842 99.7962 283.214 99.2768C282.609 98.7359 282.133 98.0759 281.786 97.297C281.462 96.518 281.299 95.7174 281.299 94.8951C281.299 93.6618 281.624 92.569 282.273 91.617C282.944 90.6432 283.864 89.8859 285.032 89.345C286.222 88.7824 287.596 88.5011 289.154 88.5011C290.712 88.5011 292.075 88.7824 293.244 89.345C294.412 89.8859 295.321 90.6432 295.97 91.617C296.641 92.569 296.976 93.6618 296.976 94.8951C296.976 95.7174 296.814 96.518 296.489 97.297C296.165 98.0759 295.689 98.7359 295.061 99.2768C294.455 99.7962 293.72 100.132 292.854 100.283L292.724 99.2119C293.72 99.385 294.596 99.7529 295.353 100.315C296.132 100.878 296.738 101.603 297.171 102.49C297.604 103.377 297.82 104.394 297.82 105.541C297.82 106.861 297.463 108.04 296.749 109.079C296.035 110.096 295.029 110.907 293.731 111.513C292.432 112.097 290.907 112.39 289.154 112.39ZM289.154 107.067C289.652 107.067 290.085 106.958 290.452 106.742C290.842 106.526 291.145 106.233 291.361 105.866C291.578 105.476 291.686 105.043 291.686 104.567C291.686 104.091 291.578 103.669 291.361 103.302C291.145 102.934 290.842 102.642 290.452 102.425C290.085 102.209 289.652 102.101 289.154 102.101C288.656 102.101 288.213 102.209 287.823 102.425C287.456 102.642 287.163 102.934 286.947 103.302C286.731 103.669 286.622 104.091 286.622 104.567C286.622 105.043 286.731 105.476 286.947 105.866C287.163 106.233 287.456 106.526 287.823 106.742C288.213 106.958 288.656 107.067 289.154 107.067ZM289.154 97.5891C289.717 97.5891 290.171 97.416 290.517 97.0698C290.885 96.7019 291.069 96.2475 291.069 95.7066C291.069 95.144 290.885 94.6787 290.517 94.3109C290.171 93.9214 289.717 93.7267 289.154 93.7267C288.592 93.7267 288.126 93.9106 287.758 94.2784C287.391 94.6247 287.207 95.0791 287.207 95.6416C287.207 96.1826 287.391 96.6478 287.758 97.0373C288.126 97.4051 288.592 97.5891 289.154 97.5891Z",
    fill: "#2C314F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2013_2527"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 112,
    fill: "white",
    transform: "translate(0 44)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomBlock8);
export default __webpack_public_path__ + "static/media/custom-block-8.128a4b05fae790a233bc35908338b41d.svg";
export { ForwardRef as ReactComponent };